import { FormieFormTheme as DefaultFormieFormTheme } from '@formie/formie-form-theme.js';
import { toast } from 'vue-sonner';
import FormieValidator from '@/lib/formie-validator.js';

/* Custom Form Theme that gets initialized in /src/formie.js (for custom validation and message handling) */
export class FormieFormTheme extends DefaultFormieFormTheme {
    constructor($form, config = {}) {
        super($form, config);

        this.formMessages = this.$form.querySelectorAll(
            '[data-slot=form-messages]'
        ); // src/components/FormMessages.vue
    }

    // overwrite this.validator to use our custom FormieValidator, otherwise same as default
    initValidator() {
        const validatorSettings = {
            live: this.validationOnFocus,

            fieldContainerErrorClass: this.form.getClasses(
                'fieldContainerError'
            ),
            inputErrorClass: this.form.getClasses('fieldInputError'),
            messagesClass: this.form.getClasses('fieldErrors'),
            messageClass: this.form.getClasses('fieldError'),
        };

        this.validator = new FormieValidator(this.$form, validatorSettings); // <== changed

        // Allow other modules to modify our validator. Use `triggerEvent` to support calling `registerEvent` as different
        // times during the app, as some fields or custom validators can be registered after this call.
        this.form.triggerEvent('registerFormieValidation', {
            validator: this.validator,
        });
    }

    showFormAlert(text, type) {
        // use toast message for alert positions set to "none"
        if (
            this.settings.submitActionMessagePosition === '' &&
            type === 'success'
        ) {
            toast.success(this.getRawText(text));
            return;
        }

        if (this.settings.errorMessagePosition === '' && type === 'error') {
            toast.error(this.getRawText(text));
            return;
        }

        if (type === 'error') {
            this.formMessages.forEach((component) =>
                component.dispatchEvent(
                    new CustomEvent('formie:show-error-message', {
                        detail: {
                            message: text,
                            position: this.settings.errorMessagePosition,
                        },
                        bubbles: false,
                    })
                )
            );
        } else if (type === 'success') {
            this.formMessages.forEach((component) =>
                component.dispatchEvent(
                    new CustomEvent('formie:show-success-message', {
                        detail: {
                            message: text,
                            position: this.settings.submitActionMessagePosition,
                        },
                        bubbles: false,
                    })
                )
            );
        }
    }

    removeFormAlert() {
        this.formMessages.forEach((component) =>
            component.dispatchEvent(
                new CustomEvent('formie:reset-messages', {
                    bubbles: false,
                })
            )
        );
    }

    getRawText(html) {
        const div = document.createElement('div');
        div.innerHTML = html;
        return div.textContent || div.innerText;
    }

    resetForm() {
        if (this.settings.scriptAttributes?.resetOnSubmit === false) {
            return;
        }

        super.resetForm();
    }
}
